/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState, useEffect, useRef } from "react";
import { cn } from "tailwind-variants";
import Preview from "./Preview.vue";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "../store";
import "./AddLetters.scss";
import { renderList } from "common/vue/render-list";

export default function AddLetters(props: any) {
  const { ...restProps } = props;
  const store = useDtfStore();
  const [textBoxes, setTextBoxes] = useState([{ value: "" }]);
  // @ts-expect-error TS(6133): 'activeTextbox' is declared but its value is never... Remove this comment to see the full error message
  const [activeTextbox, setActiveTextbox] = useState(null);
  const timerRef = useRef(null);
  const prevStyleRef = useRef(null);
  const prevTextBoxesLengthRef = useRef(textBoxes.length);

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function letterPreviewMessages() {
    // @ts-expect-error TS(4111): Property 'letterPreviewMessages' comes from an ind... Remove this comment to see the full error message
    return store.letterPreviewMessages;
  }

  function inputStyles(index: any, input: any) {
    return cn(
      "add-letters__input",
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      letterNumberArtwork().textIndex === index && !!input.value && "add-letters__input--selected"
    );
  }

  function setArtworkDefaultValues() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      textIndex: 0,
      texts: []
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.generateLettersPreview();
  }

  function handleChange(index: any, event: any) {
    const { value } = event.target;
    setActiveTextbox(index);
    const textIndex = index;
    if (!value) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.setLetterPreviewMessage({
        textIndex,
        message: null
      });
    }
    const texts = textBoxes.map(obj => obj.value);
    const quantity = texts.filter(Boolean).length;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      textIndex,
      texts,
      quantity
    });
    if (value) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.generateLettersPreview();
    }
  }

  function triggerChange(index: any, event: any) {
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    clearTimeout(timerRef.current);
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
    timerRef.current = setTimeout(() => {
      const { value } = event.target;
      if (value) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        store.setLetterPreviewLoading(true);
      }
      handleChange(index, event);
    }, 500);
  }

  function handleInput(index: any, event: any) {
    const value = event.target.value.trim();
    if (value !== "") {
      const newTextBoxes = [...textBoxes];
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      newTextBoxes[index].value = value;
      setTextBoxes(newTextBoxes);
    }
  }

  function removeTextBox(index: any) {
    if (textBoxes.length === 1) {
      setTextBoxes([{ value: "" }]);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.clearLetterPreviewMessages();
      setArtworkDefaultValues();
      return;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.removeLetterPreviewMessage(index);
    const newTextBoxes = textBoxes.filter((_, i) => i !== index);
    setTextBoxes(newTextBoxes);
    let textIndex = index;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const currentIndex = letterNumberArtwork().textIndex;
    let texts = newTextBoxes.map(obj => obj.value);
    if (textIndex < currentIndex) {
      textIndex = currentIndex - 1;
    }
    if (!texts[textIndex]) {
      const reversedTexts = [...texts].reverse();
      textIndex = texts.length - 1 - reversedTexts.findIndex(Boolean);
    }
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (newTextBoxes.length === 1 && !newTextBoxes[0].value) {
      texts = [];
    }
    const quantity = texts.filter(Boolean).length;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      textIndex,
      texts,
      quantity
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.generateLettersPreview();
  }

  function handleFocus(index: any) {
    const textBox = textBoxes[index];
    setActiveTextbox(index);
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (!textBox.value) return;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      textIndex: index
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.generateLettersPreview();
  }

  function addTextBox() {
    const currentIndex = textBoxes.length - 1;
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (!textBoxes[currentIndex].value) return;
    const newTextBoxes = [...textBoxes, { value: "" }];
    setTextBoxes(newTextBoxes);
    const texts = newTextBoxes.map(obj => obj.value);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      textIndex: currentIndex,
      texts
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.generateLettersPreview({
      useDebounce: false
    });
  }

  function handleBlur(index: any) {
    setActiveTextbox(index);
    const texts = textBoxes.map(obj => obj.value);
    const quantity = texts.filter(Boolean).length;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      texts,
      quantity
    });
  }

  useEffect(() => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const newValue = letterNumberArtwork().style;
    const oldValue = prevStyleRef.current;
    if (oldValue && newValue === null) {
      setTextBoxes([{ value: "" }]);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.clearLetterPreviewMessages();
    }
    prevStyleRef.current = newValue;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  }, [JSON.stringify(letterNumberArtwork().style)]);

  useEffect(() => {
    const prevLength = prevTextBoxesLengthRef.current;
    const currentLength = textBoxes.length;
    prevTextBoxesLengthRef.current = currentLength;
    if (currentLength > prevLength) {
      const newIndex = currentLength - 1;
      queueMicrotask(() => {
        const newTextbox = document.getElementById(`textbox-${newIndex}`);
        if (newTextbox) {
          newTextbox.focus();
        }
      });
    }
  }, [textBoxes.length]);

  return (
    <div {...restProps} className={cn("add-letters", restProps.className)}>
      <div className="add-letters__content">
        {renderList(textBoxes, (input, index) => (
          <div className="add-letters__name-wrapper" key={index}>
            <div className="add-letters__input-wrapper">
              <input
                className={cn(inputStyles(index, input))}
                id={`textbox-${index}`}
                value={input.value}
                onChange={e => {
                  const newTextBoxes = [...textBoxes];
                  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                  newTextBoxes[index].value = e.target.value.trim();
                  setTextBoxes(newTextBoxes);
                  handleInput(index, e);
                }}
                type="text"
                onFocus={() => {
                  handleFocus(index);
                }}
                onBlur={() => {
                  handleBlur(index);
                }}
                onKeyDown={e => {
                  if (e.key !== "Enter") return;
                  e.preventDefault();
                  // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
                  addTextBox(e);
                }}
                onKeyUp={e => {
                  triggerChange(index, e);
                }}
                data-testid="add-letters-input"
              />
              {/* @ts-expect-error TS(2571): Object is of type 'unknown'. */}
              {letterPreviewMessages()[index] ? (
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                <div className="add-letters__error">{letterPreviewMessages()[index]}</div>
              ) : null}
            </div>
            <button
              className="add-letters__button add-letters__button--remove"
              type="button"
              onClick={() => {
                removeTextBox(index);
              }}
              data-testid="add-letters-button"
            >
              <UseSvg
                className="add-letters__remove-icon"
                icon="modal-close"
                data-testid="add-letters-remove-icon"
              />
            </button>
          </div>
        ))}
        <div className="add-letters__new-name">
          <button
            className="add-letters__button"
            type="button"
            onClick={addTextBox}
            data-testid="add-letters-button-1"
          >
            {" "}
            + Add another name{" "}
          </button>
        </div>
      </div>
      <div className="add-letters__content">
        <Preview data-testid="preview" />
      </div>
    </div>
  );
}
